import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("b", null, "Weet u zeker dat u uw afbouw keuzes wilt resetten?", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import { ref } from 'vue'
import { ReloadOutlined } from '@ant-design/icons-vue'
import axios from 'axios'
import { summaryStore } from '@/stores/v2/summary'
import { notification } from 'ant-design-vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'WoononResetCompletionButton',
  setup(__props) {

const resetting = ref(false)

function resetCompletion () : void {
  resetting.value = true
  axios.get(process.env.VUE_APP_API_URL_V2 + '/summary/completion/reset').then((r) => {
    summaryStore().summary = r.data
    notification.success({
      message: 'Afbouw succesvol gereset.',
      description: 'Uw afbouw keuzes zijn succesvol gereset.',
      duration: 5
    })
  }).catch(() => {
    notification.error({
      message: 'Afbouw NIET gereset!',
      description: 'Er is iets mis gegaan. Probeer het later nog eens.',
      duration: 0
    })
  }).finally(() => {
    resetting.value = false
  })
}

return (_ctx: any,_cache: any) => {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_popconfirm = _resolveComponent("a-popconfirm")!

  return (_openBlock(), _createBlock(_component_a_popconfirm, {
    placement: "topLeft",
    "ok-text": "Ja, reset mijn afbouw keuzes",
    onConfirm: resetCompletion
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _hoisted_2,
      _createTextVNode(" Alle afbouw opties zullen worden terug gezet naar de standaard."),
      _hoisted_3,
      _createTextVNode(" Dit betekend dat al uw gemaakte afbouw keuzes verloren gaan! ")
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_button, {
        loading: resetting.value,
        disabled: resetting.value
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(ReloadOutlined)),
          _createTextVNode(" Afbouw keuzes resetten ")
        ]),
        _: 1
      }, 8, ["loading", "disabled"])
    ]),
    _: 1
  }))
}
}

})